'use client'

import { useRouter } from 'next/navigation'
import { Badge } from 'shared/antd/ui/Badge'
import { Icon } from 'shared/iconpack'
import {
  DefaultKeyToStorage,
  OwnerIdKeyToStorage,
  TokenStorage,
  getLocalStorage,
  setLocalStorage,
} from 'shared/libs/storage'
import { clsx } from 'shared/libs/style-merge'
import { v4 as uuidv4 } from 'uuid'

import { useEffect } from 'react'

import { useCart } from 'modules/Cart/hooks'
import { useCartSlice } from 'modules/Cart/model/cart.slice'

import { ROUTER_PATHS } from 'shared/config/routerPath/RouterPath'
import { globalStyles } from 'shared/config/styles/globalStyles'

import styles from './CartBadge.module.scss'

interface CartBadgeProps {
  isMobile?: boolean
  isActive?: boolean
  className?: string
}

export function CartBadge({
  isMobile = false,
  isActive = false,
  className,
}: CartBadgeProps) {
  const router = useRouter()
  useCartSlice()
  const token = TokenStorage.getFromStorage(DefaultKeyToStorage)
  const { getCarts, totalProductsCount } = useCart()

  useEffect(() => {
    const ownerId = getLocalStorage(OwnerIdKeyToStorage)
    if (!token && !ownerId) {
      const uuid = uuidv4()
      setLocalStorage({ key: OwnerIdKeyToStorage, value: uuid })
    }
    getCarts()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token])

  return (
    <button
      onClick={() => router.push(ROUTER_PATHS.cart)}
      className={clsx(
        styles.actionButton,
        { [styles.active]: isActive },
        className,
      )}
    >
      <Badge
        className={styles.badge}
        count={totalProductsCount}
        size={isMobile ? 'small' : 'default'}
      >
        <Icon
          name={isMobile ? 'shopCart' : 'cart'}
          size={isMobile ? 20 : 28}
          color={
            isMobile
              ? isActive
                ? globalStyles['--icon-sucess']
                : globalStyles['--icon-secondary']
              : '#40474F'
          }
        />
      </Badge>
      <p>Корзина</p>
    </button>
  )
}
